import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import "./AuthPage.css";

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [serverMessage, setServerMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }

    fetch(`${process.env.REACT_APP_BASE_URL}/verify-email/${token}/`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          if (data.message) setServerMessage(data.message);
          setStatus("success");
          setTimeout(() => navigate("/login"), 5000);
        } else {
          setStatus("error");
        }
      })
      .catch(() => setStatus("error"));
  }, [token, navigate]);

  const statusContent = {
    loading: {
      icon: <span className="auth-verify-spinner" aria-hidden="true" />,
      title: "Verifying your email…",
      message: "Please wait while we confirm your account.",
    },
    success: {
      icon: <div className="auth-success-icon" aria-hidden="true">✓</div>,
      title: "Email verified!",
      message: serverMessage || "Email successfully verified. Your account is now pending approval.",
    },
    error: {
      icon: <div className="auth-error-icon" aria-hidden="true">!</div>,
      title: "Verification failed",
      message: "Invalid or expired link. Please request a new one.",
    },
  };

  const { icon, title, message } = statusContent[status];

  return (
    <div className="auth-verify-page">
      <div className="auth-verify-card auth-form-animate">
        <img
          className="auth-form-logo auth-verify-logo"
          src="/StratusEdgeFinal_whiteupscaled.png"
          alt="Edge AI"
        />
        <div className={`auth-verify-status auth-verify-status--${status}`}>
          {icon}
          <h2 className="auth-verify-title">{title}</h2>
          <p className="auth-verify-message">{message}</p>
          {status === "success" && (
            <p className="auth-verify-message">Redirecting to login…</p>
          )}
        </div>
        {status === "error" && (
          <div className="auth-verify-actions">
            <Link to="/register" className="auth-link-inline">Create account</Link>
            <span className="auth-verify-sep">·</span>
            <Link to="/login" className="auth-link-inline">Sign in</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
